import React from 'react'
import * as Yup from 'yup'

import { TtButton, TtCard } from '@23/ui-react'
import * as TtForms from '@23/react-forms'

import type { WidgetDTO } from '../../../../../../model/Widget'

const buttonSchema = Yup.object({
  label: Yup.string().required('Label is required').trim(),
  link: Yup.string()
    .trim()
    .transform((v) => (v === '' ? undefined : v))
    .optional()
    .url('Invalid URL format'),
})

type FormValues = Yup.InferType<typeof buttonSchema>

interface ButtonEditModeProps {
  widget: WidgetDTO
  onSave: (values: FormValues) => Promise<void>
  onCancel: () => void
}

const ButtonEditMode = ({ widget, onSave, onCancel }: ButtonEditModeProps) => (
  <TtCard
    className="personal-widget-button personal-widget-button--edit"
    hideLabel
  >
    <TtForms.Form<FormValues>
      className="personal-widget-button-form"
      label="Edit button"
      initialValues={{
        label: widget.label ?? '',
        link: widget.link ?? '',
      }}
      validationSchema={buttonSchema}
      onSubmit={onSave}
      enableReinitialize
    >
      <TtForms.TextField
        name="label"
        label="Button Label"
        placeholder="Button Label"
        required
      />
      <TtForms.TextField
        name="link"
        label="Link URL"
        placeholder="https://example.com"
      />
      <div className="personal-widget-button-form-actions">
        <TtButton variant="outline" color="secondary" onClick={onCancel}>
          Cancel
        </TtButton>
        <TtForms.SubmitButton color="primary" disabled={false}>
          Save
        </TtForms.SubmitButton>
      </div>
    </TtForms.Form>
  </TtCard>
)

export { type FormValues as ButtonFormValues, ButtonEditMode }
